/* Oddity Shack v78: accessible product tabs, readable long descriptions, and
   gallery arrow controls that use the existing Shopify thumbnail functionality. */
(() => {
  function initTabs(root) {
    if (!root || root.dataset.os78Initialized) return;
    root.dataset.os78Initialized = 'true';
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    const activate = (chosen, focus) => {
      tabs.forEach((tab) => {
        const active = tab === chosen;
        const id = tab.getAttribute('aria-controls');
        const panel = id ? document.getElementById(id) : null;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        tab.classList.toggle('is-active', active);
        if (panel) panel.hidden = !active;
      });
      if (focus) chosen.focus();
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activate(tab, false));
      tab.addEventListener('keydown', (event) => {
        let next = null;
        if (event.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        else if (event.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (event.key === 'Home') next = tabs[0];
        else if (event.key === 'End') next = tabs[tabs.length - 1];
        if (next) { event.preventDefault(); activate(next, true); }
      });
    });

    const copy = root.querySelector('[data-os78-description]');
    const more = root.querySelector('[data-os78-more]');
    if (copy && more) {
      const assess = () => {
        if (copy.classList.contains('is-expanded')) return;
        more.hidden = copy.scrollHeight <= copy.clientHeight + 7;
      };
      more.addEventListener('click', () => {
        const expanded = copy.classList.toggle('is-expanded');
        more.textContent = expanded ? 'Show less ↑' : 'Read full description ↓';
        more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        more.hidden = false;
      });
      assess();
      window.addEventListener('resize', assess, { passive: true });
    }
  }

  function initGallery(gallery) {
    if (!gallery || gallery.dataset.os78ArrowsReady) return;
    const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
    const thumbList = gallery.querySelector('[id^="Slider-Thumbnails-"]');
    if (!viewer || !thumbList) return;
    const buttons = Array.from(thumbList.querySelectorAll('.thumbnail-list__item button'));
    const arrows = Array.from(viewer.querySelectorAll('.slider-buttons .slider-button'));
    if (buttons.length <= 1) {
      arrows.forEach((b) => { b.hidden = true; });
      return;
    }
    gallery.dataset.os78ArrowsReady = 'true';
    arrows.forEach((arrow) => {
      arrow.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        const current = Math.max(0, buttons.findIndex((b) => b.hasAttribute('aria-current')));
        const direction = arrow.classList.contains('slider-button--prev') ? -1 : 1;
        buttons[(current + direction + buttons.length) % buttons.length].click();
      }, true);
    });
  }

  const init = () => {
    document.querySelectorAll('[data-os78-tabs]').forEach(initTabs);
    document.querySelectorAll('body.os76-product #MainContent media-gallery').forEach(initGallery);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
